// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-annotator {
  position: absolute;
  inset: 0;
  z-index: 6;
  pointer-events: none;
}

.video-annotator--frame {
  inset: auto;
}

.video-annotator.is-drawing {
  z-index: 45;
  pointer-events: auto;
  background: rgba(2, 6, 23, 0.18);
}

.video-annotator.is-drawing.is-playing {
  pointer-events: none;
  background: transparent;
}

.video-annotator.is-drawing.is-playing .video-annotator__canvas,
.video-annotator.is-drawing.is-playing .video-annotator__hit {
  pointer-events: none;
  cursor: default;
}

.video-annotator.is-drawing.is-playing .video-annotator__bar {
  pointer-events: auto;
}

.video-annotator__canvas,
.video-annotator__hit {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  touch-action: none;
}

.video-annotator__canvas {
  pointer-events: none;
}

.video-annotator.is-drawing:not(.is-playing) .video-annotator__hit {
  pointer-events: auto;
  cursor: crosshair;
}

.video-annotator.is-playback .video-annotator__canvas {
  pointer-events: none;
}

.video-annotator__bar {
  position: absolute;
  z-index: 50;
  top: max(12px, env(safe-area-inset-top, 0px));
  left: max(8px, env(safe-area-inset-left, 0px));
  right: auto;
  bottom: auto;
  width: auto;
  max-height: calc(
    100% - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  );
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 8px;
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.92);
  color: #fff;
  pointer-events: auto;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
  overflow: auto;
}

.video-annotator__close {
  align-self: flex-end;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
}

.video-annotator__rail {
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  align-items: start;
}

.video-annotator__actions,
.video-annotator__colors {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
}

.video-annotator__group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.14);
}

.video-annotator__group:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.video-annotator__bar button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
}

.video-annotator__bar button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.video-annotator__bar button.is-on,
.video-annotator__swatch.is-on {
  box-shadow: 0 0 0 2px #fff;
}

.video-annotator__bar button.is-rec,
.video-annotator__record.is-rec {
  background: #ef4444;
}

.video-annotator__swatch {
  width: 22px !important;
  height: 22px !important;
  border-radius: 999px !important;
}

.video-annotator__record,
.video-annotator__replay,
.video-annotator__save {
  width: auto !important;
  min-width: 34px;
  height: auto !important;
  min-height: 34px;
  padding: 6px 8px;
  gap: 4px;
  font-size: 11px;
  font-weight: 750;
  line-height: 1.1;
}

.video-annotator__audio,
.video-annotator__playback audio {
  height: 32px;
  max-width: 140px;
}

.video-annotator__timer {
  min-width: 28px;
  font-size: 11px;
  font-weight: 750;
  color: #fecaca;
  text-align: center;
}

.video-annotator__status {
  margin: 0;
  max-width: 128px;
  font-size: 11px;
  color: #fde68a;
}

.video-annotator__playback {
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
  padding: 6px 8px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.82);
}

.video-annotator__playback button {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/VideoFrameAnnotator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,6CAA6C;EAC7C,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,WAAW;EACX;;GAEC;EACD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;AACjB","sourcesContent":[".video-annotator {\n  position: absolute;\n  inset: 0;\n  z-index: 6;\n  pointer-events: none;\n}\n\n.video-annotator--frame {\n  inset: auto;\n}\n\n.video-annotator.is-drawing {\n  z-index: 45;\n  pointer-events: auto;\n  background: rgba(2, 6, 23, 0.18);\n}\n\n.video-annotator.is-drawing.is-playing {\n  pointer-events: none;\n  background: transparent;\n}\n\n.video-annotator.is-drawing.is-playing .video-annotator__canvas,\n.video-annotator.is-drawing.is-playing .video-annotator__hit {\n  pointer-events: none;\n  cursor: default;\n}\n\n.video-annotator.is-drawing.is-playing .video-annotator__bar {\n  pointer-events: auto;\n}\n\n.video-annotator__canvas,\n.video-annotator__hit {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  touch-action: none;\n}\n\n.video-annotator__canvas {\n  pointer-events: none;\n}\n\n.video-annotator.is-drawing:not(.is-playing) .video-annotator__hit {\n  pointer-events: auto;\n  cursor: crosshair;\n}\n\n.video-annotator.is-playback .video-annotator__canvas {\n  pointer-events: none;\n}\n\n.video-annotator__bar {\n  position: absolute;\n  z-index: 50;\n  top: max(12px, env(safe-area-inset-top, 0px));\n  left: max(8px, env(safe-area-inset-left, 0px));\n  right: auto;\n  bottom: auto;\n  width: auto;\n  max-height: calc(\n    100% - 24px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  );\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 16px;\n  background: rgba(15, 23, 42, 0.92);\n  color: #fff;\n  pointer-events: auto;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);\n  overflow: auto;\n}\n\n.video-annotator__close {\n  align-self: flex-end;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n}\n\n.video-annotator__rail {\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 8px;\n  align-items: start;\n}\n\n.video-annotator__actions,\n.video-annotator__colors {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.video-annotator__group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.14);\n}\n\n.video-annotator__group:last-child {\n  padding-bottom: 0;\n  border-bottom: 0;\n}\n\n.video-annotator__bar button {\n  width: 34px;\n  height: 34px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  cursor: pointer;\n}\n\n.video-annotator__bar button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.video-annotator__bar button.is-on,\n.video-annotator__swatch.is-on {\n  box-shadow: 0 0 0 2px #fff;\n}\n\n.video-annotator__bar button.is-rec,\n.video-annotator__record.is-rec {\n  background: #ef4444;\n}\n\n.video-annotator__swatch {\n  width: 22px !important;\n  height: 22px !important;\n  border-radius: 999px !important;\n}\n\n.video-annotator__record,\n.video-annotator__replay,\n.video-annotator__save {\n  width: auto !important;\n  min-width: 34px;\n  height: auto !important;\n  min-height: 34px;\n  padding: 6px 8px;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 750;\n  line-height: 1.1;\n}\n\n.video-annotator__audio,\n.video-annotator__playback audio {\n  height: 32px;\n  max-width: 140px;\n}\n\n.video-annotator__timer {\n  min-width: 28px;\n  font-size: 11px;\n  font-weight: 750;\n  color: #fecaca;\n  text-align: center;\n}\n\n.video-annotator__status {\n  margin: 0;\n  max-width: 128px;\n  font-size: 11px;\n  color: #fde68a;\n}\n\n.video-annotator__playback {\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  pointer-events: auto;\n  padding: 6px 8px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.82);\n}\n\n.video-annotator__playback button {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
